const duplicateTranslationKey = (key: string): string => key;

/**
 * Every return rate is reported on matured orders only, so each tooltip has to
 * say so — a reader who does not know that reads an unfinished rate as a low
 * one.
 */
const MATURITY_NOTE_DA =
  "\nRaten opgøres kun på ordrer der er mindst 30 dage gamle, så returneringer har haft tid til at nå frem — derfor står der N/A indtil butikken har været forbundet så længe.";

export const translationStatistics_da_part4 = {
  // Business hours and time period filter translations
  businessHours: "Åbningstider",
  businessHoursDescription:
    "Indstil dine kundeservice-tider for at spore beskeder sendt uden for åbningstider.",
  startTime: "Start tid",
  endTime: "Slut tid",
  currentBusinessHours: "Nuværende åbningstider",
  businessHoursNote: "Ændringer gemmes automatisk og påvirker fremtidige statistikberegninger.",

  // Weekend hours translations

  // Weekend hours translations
  weekendHours: "Åbningstider (Lørdag/Søndag)",
  saturdayHours: "Lørdag",
  sundayHours: "Søndag",

  timePeriodFilter: "Tidsperiode filter",
  timePeriodFilterDescription: "Vælg hvilken tidsperiode af dagen du vil se samtaler fra.",
  filterStartTime: "Filter start tid",
  filterEndTime: "Filter slut tid",
  enableTimePeriodFilter: "Aktiver tidsperiode filter",
  currentTimePeriodFilter: "Nuværende tidsperiode filter",
  timePeriodFilterNote:
    "Når aktiveret, vises kun samtaler fra den valgte tidsperiode i statistikkerne.",
  outsideBusinessHours: "Uden for åbningstider",
  outsideBusinessHoursTooltip: "Procent af beskeder sendt uden for virksomhedens åbningstider",

  // TTFT (Time to First Token) translations

  // TTFT (Time to First Token) translations
  averageTtft: "Gns. tid til første token",
  averageTtftTooltip: "Gennemsnitlig tid fra besked modtages til første token sendes",
  p50Ttft: "P50 tid til første token",
  p50TtftTooltip: "Median (50-percentil) tid fra besked modtages til første token sendes",
  p95Ttft: "P95 tid til første token",
  p95TtftTooltip: "95-percentil tid fra besked modtages til første token sendes",
  p99Ttft: "P99 tid til første token",
  p99TtftTooltip: "99-percentil tid fra besked modtages til første token sendes",
  responseLatencyMetrics: "Svartider (TTFT, P50, P95)",
  responseLatencyMetricsTooltip:
    "Vis tid til første token samt P50- og P95-svartider på statistiksiden",
  p99LatencyMetric: "Svartid (P99)",
  p99LatencyMetricTooltip: "Vis P99-tid til første token på statistiksiden",
  ttftBreakdownLabel: "Tidsfordeling til første token",
  totalTtft: "Total TTFT",
  detailedBreakdown: "Detaljeret tidsfordeling (i rækkefølge)",
  noTtftData: "Ingen TTFT data tilgængelig",

  supportHours: "Åbningstider support",
  weekendSupport: "Support i weekenden",

  // Settings and saving translations

  // Settings and saving translations
  saving: "Gemmer...",
  saveSettings: "Gem Indstillinger",
  settingsSaved: "Indstillinger gemt succesfuldt",
  settingsSaveError: "Fejl ved gemning af indstillinger",
  businessHoursInvalidRange:
    "Sluttid skal være senere end starttid. Åbningstiderne blev ikke gemt.",

  // Settings placeholder translations

  // Settings placeholder translations
  settingsComingSoon: "Indstillinger kommer snart",
  settingsComingSoonDescription:
    "Statistik indstillinger og præferencer vil være tilgængelige i en fremtidig opdatering. Hold øje med flere tilpasningsmuligheder!",

  // Modal translations

  // Modal translations
  qualityMetrics: "Kvalitetsmetrikker",
  statisticsFor: "Statistik for",
  close: "Luk",
  goToConversations: "Se samtaler",
  viewPurchases: "Se køb",
  viewLeads: "Se leads",
  [duplicateTranslationKey("loading")]: "Indlæser...",
  leads: "Kontaktformular",

  // Contact formula tracking translations

  // Contact formula tracking translations
  totalContactFormulas: "Brugte kontaktformularer",
  contactFormulas: "Kontaktformularer",
  contactFormulaConversionRate: "Brugte kontaktformular",

  // Tooltip translations for info icons

  // Tooltip translations for info icons
  totalMessagesTooltip:
    "Det samlede antal beskeder sendt af brugere til chatbotten i den valgte periode",
  avgMessagesPerDayTooltip:
    "Gennemsnitligt antal brugerbeskeder per dag baseret på de dage, hvor der var aktivitet",
  totalConversationsTooltip:
    "Det samlede antal samtaler (sessioner) startet med chatbotten i den valgte periode",
  totalUserRatingsTooltip:
    "Antal gange brugere har givet en vurdering eller feedback efter deres samtale",
  averageRatingTooltip:
    "Gennemsnitlig vurdering givet af brugere efter deres samtale med chatbotten",
  thumbsUpPercentageTooltip: "Procentdel af brugere der gav en positiv vurdering (tommel op)",
  csatScoreTooltip:
    "Kundetilfredshedscore - procentdel af vurderinger der var 4 stjerner eller højere (eller tommel op)",
  chatbotSatisfactionTooltip:
    "Chatbot tilfredshed - CSAT score beregnet kun fra samtaler der ikke resulterede i en fallback til menneskelig kundeservice",
  totalPurchasesTooltip:
    "Antal registrerede køb fra brugere der har haft en samtale med chatbotten.\nVi sporer konverteringer indtil kunden klikker på 'betal' og åbner det eksterne betalingsvindue.",
  totalRevenueTooltip:
    "Samlet omsætning fra køb foretaget af brugere der har interageret med chatbotten.\nVi sporer konverteringer indtil kunden klikker på 'betal' og åbner det eksterne betalingsvindue.",
  storeTotalPurchasesTooltip:
    "Alle ordrer registreret i den tilknyttede butik (Shopify eller Orders API) i perioden, uanset om kunden har talt med chatbotten.",
  storeTotalRevenueTooltip:
    "Samlet omsætning fra alle ordrer i den tilknyttede butik (Shopify eller Orders API) i perioden, uanset om kunden har talt med chatbotten.",
  storeAveragePurchaseValueTooltip:
    "Gennemsnitlig værdi af alle ordrer i den tilknyttede butik (Shopify eller Orders API) i perioden, uanset om kunden har talt med chatbotten (butikkens omsætning divideret med antal ordrer).",
  returnRateTooltip:
    "Andel af ordrer fra brugere der har talt med chatbotten hvor mindst én vare er sendt tilbage." +
    MATURITY_NOTE_DA +
    "\nBemærk: kunder der spørger chatbotten er ikke et tilfældigt udsnit af kunderne, så forskellen til butikkens rate er ikke i sig selv et bevis for chatbottens effekt.",
  returnValueRateTooltip:
    "Værdien af varer sendt tilbage, som andel af ordreværdien, for brugere der har talt med chatbotten.\nKun egentlige returneringer tælles — annulleringer og kulancerefusioner hører ikke med." +
    MATURITY_NOTE_DA,
  returnUnitRateTooltip:
    "Antal varer sendt tilbage, som andel af antal købte varer, for brugere der har talt med chatbotten.\nDen mest retvisende rate når kunder ofte returnerer en del af en ordre." +
    MATURITY_NOTE_DA,
  storeReturnRateTooltip:
    "Andel af alle ordrer i den tilknyttede butik (Shopify eller Orders API) hvor mindst én vare er sendt tilbage, uanset om kunden har talt med chatbotten." +
    MATURITY_NOTE_DA,
  storeReturnValueRateTooltip:
    "Værdien af varer sendt tilbage, som andel af ordreværdien, for alle ordrer i butikken." +
    MATURITY_NOTE_DA,
  storeReturnUnitRateTooltip:
    "Antal varer sendt tilbage, som andel af antal købte varer, for alle ordrer i butikken." +
    MATURITY_NOTE_DA,
  returnCohortBasisTooltip:
    "Hvor mange ordrer raten er beregnet på, og hvor gamle de mindst skal være.",
  storeConversionRateTooltip:
    "Andel af butiksbesøg der endte med et køb (alle ordrer divideret med butikssessioner).\nSessioner måles af Shopify web-pixelen, så raten dækker kun perioden efter pixelen blev aktiv.",
  storeConversionRateVisitorsTooltip:
    "Butikkens ordrer divideret med daglige besøgende, som chatbotten tæller dem: hver browser én gang om dagen, på sider hvor chatbotten indlæses.\nBesøgende der fravælger ikke-nødvendige cookies tælles ikke med, så raten er højere end over alle besøgende. Kun webordrer afgivet efter at besøgende begyndte at blive talt indgår.",
  averagePurchaseValueTooltip:
    "Gennemsnitlig værdi af køb foretaget af brugere der har interageret med chatbotten.\nVi sporer konverteringer indtil kunden klikker på 'betal' og åbner det eksterne betalingsvindue.",
  conversionRateTooltip:
    "Hvor mange procent endte med at foretage et køb efter at have haft en samtale med chatbotten.\nVi sporer konverteringer indtil kunden klikker på 'betal' og åbner det eksterne betalingsvindue.",
  fallbackRateTooltip:
    "AI vurdering af hvor mange samtaler chatbotten ikke kunne besvare eller forstå sikkert på grund af manglende indhold, uklart spørgsmål eller retrieval gap",
  resolutionRateTooltip:
    "Procent af samtaler der blev løst af chatbotten uden at kræve kundeservice som næste skridt",
  handoverRequiredRateTooltip:
    "Procent af samtaler hvor sagen reelt krævede kundeservice eller en manuel proces",
  userRequestedCustomerServiceRateTooltip:
    "Procent af samtaler hvor brugeren selv bad om kundeservice, livechat eller support",
  ligegyldigRateTooltip:
    'AI vurdering af hvor mange procent af samtalerne kun består af ligegyldige beskeder som "hej" uden egentligt indhold',
  totalContactFormulasTooltip:
    "Antal samtaler hvor kunden har indsendt kontaktformular eller support henvendelse. Du kan se disse kontaktformularer ved at bruge filter knappen på samtaler siden",
  contactFormulaConversionRateTooltip:
    "Procent af samtaler hvor kunden brugte kontaktformular eller sendte en supporthenvendelse",
  engagementRate: "Engagementsrate",
  engagementRateTooltip: "Procent af besøgende der åbnede chatbotten og faktisk sendte en besked",
  conversationSources: "Samtalekilder",
  conversationSourcesTooltip:
    "Viser hvordan samtaler blev startet, så du kan se brugen af forskellige integrationskilder",
  viewContactFormulas: "Se kontaktformularer",
  tagsViewExplanation:
    "Du kan se samtaler i hver underemne og kategori ved at filtrere med den lille filterknap på samtalesiden",
  clickToViewTags: "Klik for at se underemner",
  tagDistribution: "Underemner",
  tagDistributionFor: "Underemne fordeling for",
  tagDistributionDescription: "Underemner associeret med dette emne:",
  noTagsFound: "Ingen underemner fundet for dette emne.",

  companyInfoPlaceholderDescription:
    "Indtast virksomhedsinfo, branche og eventuelle kontekst, der vil hjælpe AI med at generere bedre indsigter",
};
